@if (isRegular()) {
  <fa-icon
    [icon]="iconDefinition"
    [fixedWidth]="true"
    [spin]="spin"
    [pulse]="pulse"
    [classes]="classes()">
  </fa-icon>
}
@if (isStack()) {
  <fa-stack>
    <fa-icon
      [icon]="iconDefinition"
      [spin]="spin"
      [pulse]="pulse"
      [classes]="classes()"
      stackItemSize="2x"
      >
    </fa-icon>
    <fa-icon
      [icon]="iconDefinition2"
      [spin]="spin"
      [pulse]="pulse"
      [inverse]="true"
      stackItemSize="1x"
      >
    </fa-icon>
  </fa-stack>
}
@if (isNumber()) {
  <div class="flex numbers">
    @for (icon of iconNumberDefinitions; track icon; let i = $index) {
      <fa-icon
        [icon]="icon"
      [class]="'num-' + i"></fa-icon>
    }
  </div>
}
